import { useEffect, RefObject } from "react"
import { Editor as TiptapEditor } from "@tiptap/react"

interface UsePendingScrollProps {
  pendingScrollLine?: number | null
  onClearPendingScroll?: () => void
  editor: TiptapEditor | null
  editorContainerRef: RefObject<HTMLDivElement | null>
}

/**
 * Hook to handle scrolling to a specific line after variant switch.
 * Waits for editor content to load before scrolling.
 */
export const usePendingScroll = ({
  pendingScrollLine,
  onClearPendingScroll,
  editor,
  editorContainerRef,
}: UsePendingScrollProps): void => {
  useEffect(() => {
    if (pendingScrollLine && editor) {
      const lineNumber = pendingScrollLine
      // Wait for editor content to fully load
      setTimeout(() => {
        // Check if editor is still valid (not destroyed during remount)
        if (!editor.view || !editor.view.dom) {
          if (onClearPendingScroll) {
            onClearPendingScroll()
          }
          return
        }
        const lines = editor.view.dom.querySelectorAll(
          ".ProseMirror > *"
        ) as NodeListOf<HTMLElement>
        if (lineNumber >= 1 && lineNumber <= lines.length) {
          const lineY = lines[lineNumber - 1].offsetTop
          editorContainerRef.current?.scrollTo({
            top: lineY,
            behavior: "smooth",
          })
        }
        // Clear the pending scroll in parent AFTER scrolling
        if (onClearPendingScroll) {
          onClearPendingScroll()
        }
      }, 1000)
    }
  }, [pendingScrollLine, editor, onClearPendingScroll, editorContainerRef])
}
